import React from 'react';

import LootboxApi from '../../../../Api/CRM/Modules/Lootbox/LootboxApi';
import LootboxResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxResponse';
import GetLootboxResponse from '../../../../Api/CRM/Responses/Lootbox/LootboxResponse';
import * as formatters from '../../../../utils/formatters';
import Search from '../../../elements/Search';
import BooleanIcon from '../../../elements/booleanIcon';
import Card from '../../../elements/common/Card';
import FilterByColumn, { Filter } from '../../../elements/common/FilterByColumn';
import SortButton from '../../../elements/common/SortButton';
import { TableCell as Cell } from '../../../elements/common/TableDetailsRow';
import TableHead from '../../../elements/common/TableHead';
import TableLoader from '../../../elements/common/TableLoader';
import Paginator from '../../../elements/paginator';
import useAutoPaginator from '../../../hooks/useAutoPaginator';

function LootboxPage() {
    const { items, isLoading, auto } = useAutoPaginator<GetLootboxResponse>((page, params) =>
        LootboxApi.getAll(page, { params })
    );

    return (
        <Card title="All Lootboxes">
            <Search {...auto.search} />
            <FilterByColumn {...auto.filter}>
                <Filter column="created_at" label="Created at" type="dateRange" />
            </FilterByColumn>
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <th>Name</th>
                        <th>Slug</th>
                        <th>Is Enabled</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th>Price Currency Code</th>
                        <SortButton column="created_at" order="desc" {...auto.sort} />
                    </TableHead>
                    <LootboxListTableBody lootboxes={items} />
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

function LootboxListTableBody({ lootboxes }: { lootboxes: LootboxResponse[] }) {
    const { formatDateStringWithTimezone } = formatters;

    return (
        <tbody>
            {lootboxes.map((lootbox) => (
                <tr key={lootbox.id}>
                    <td>{lootbox.name}</td>
                    <td>{lootbox.slug}</td>
                    <td>
                        <BooleanIcon value={lootbox.is_enabled} />
                    </td>
                    <td>{lootbox.description}</td>
                    <td>{lootbox.price}</td>
                    <td>{lootbox.price_currency_code}</td>
                    <Cell>{formatDateStringWithTimezone(lootbox.created_at)}</Cell>
                </tr>
            ))}
        </tbody>
    );
}

export default LootboxPage;
